import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'components/Modal'
import FontIcon from 'components/FontIcon'
import Button from 'components/Button'
import { useHistory } from 'react-router-dom'
import styles from './NoWin.module.scss'
import { path } from 'utils/const'
import { images } from 'assets'
import CardButton from 'pageComponents/CardButton'

const NoWin = ({
  tiles,
  isWinPattern, back,
  onClick
}) => {


  // alert(JSON.stringify(groupedData))
  return <div  >
    <div className={styles.wrapper} onClick={() => onClick()}>
      <div style={{ display: 'flex', flexDirection: 'column', backgroundSize: 'cover', flex: 1, backgroundColor: '#000000bf', justifyContent: 'center', alignItems: 'center' }}>


        <div class="animate__animated animate__bounceIn" style={{ width: '94%', backgroundColor: '#ecedef', borderRadius: 16, }}>
          <div className={styles.imgButtonImg} style={{ borderRadius: 16, flex: 2, padding: 3, display: 'flex', aspectRatio: '4/2', backgroundImage: "linear-gradient(#ffe500,#ff7a01)", }}>


            <div className={styles.modalBackground} style={{ padding: '8%', borderRadius: 16, backgroundSize: 'cover', backgroundPosition: 'center', flex: 1, }}>
              <div style={{ flex: 1, borderRadius: 16, height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
                <p className={styles.nowin} style={{

                }}>NO Win</p>
              </div>

            </div>
          </div>



        </div>

      </div>
    </div>
  </div>
}

// SentResetPassword.propTypes = {
//   email: PropTypes.string,
//   isOpen: PropTypes.bool,
//   toggle: PropTypes.func,
//   onSubmit: PropTypes.func,
// }

// SentResetPassword.defaultProps = {
//   email: '',
//   isOpen: false,
//   toggle: () => {},
//   onSubmit: () => {},
// }

export default NoWin
